"use client";

import { observer } from "mobx-react";
import { useStores } from "@soprisapps/components/stores/useStores";
import AdminMenu from "@soprisapps/components/components/misc/AdminMenu";
import { IView } from "@soprisapps/components/stores/InterfaceStore";

const showAdminMenu = [
  IView.DEFAULT,
  IView.ALPHA,
  IView.MAP,
  IView.CLASSROOM,
  IView.CALENDAR,
  IView.PAGE,
  IView.ORGANIZATION_PAGE,
  IView.LIST,
];

export const AdminMenuClientWrapper = observer(() => {
  const { userStore, interfaceStore } = useStores();

  return userStore.isEditor && showAdminMenu.includes(interfaceStore.view) ? (
    <AdminMenu key={interfaceStore.currentFullUrl} />
  ) : null;
});
